import { getModerationItemsKey } from '../../utils/keys';
export const removeFromModerationItems = (moderationItemId, queryClient) => {
    const moderationItemsKey = getModerationItemsKey();
    queryClient.setQueriesData(moderationItemsKey, old => ({
        ...old,
        pages: old.pages.map(page => ({
            ...page,
            edges: page.edges.filter(edge => edge.node.id !== moderationItemId),
            nodes: page.nodes.filter(node => node.id !== moderationItemId),
        })),
    }));
};
//# sourceMappingURL=useCachedModerationItem.js.map